import type { PageContext, PageContextEntities } from '@/hooks/use-folio-stream';

export function resolveFolioProjectId(entities: PageContextEntities): string | null {
  const projectId = entities.project_id;
  return projectId === undefined || projectId.length === 0 ? null : projectId;
}

export function hasFolioProjectScopeMismatch(
  conversationProjectId: string | null | undefined,
  pageContext: PageContext,
): boolean {
  if (conversationProjectId === null || conversationProjectId === undefined) {
    return false;
  }
  const currentProjectId = resolveFolioProjectId(pageContext.entities);
  return currentProjectId !== null && currentProjectId !== conversationProjectId;
}
